module.exports = __webpack_public_path__ + "static/media/mountain_biking_640.0c72d370.webp";